module.exports = __webpack_public_path__ + "static/media/up-arrow.8b0f7646.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/up-arrow.svg
// module id = 707
// module chunks = 0